import React from 'react';
import {
  Truck, Package, Route, Users, GraduationCap, LineChart, MapPin,
} from 'lucide-react';

const stats = [
  {
    icon: Truck,
    stat: '80,000+',
    label: 'Truck driver shortage projected in the U.S. by 2030',
    tag: 'Transportation',
    span: 'md:col-span-2',
  },
  {
    icon: Package,
    stat: '$1.6T',
    label: 'U.S. logistics market size — a growing engine of opportunity',
    tag: 'Logistics',
  },
  {
    icon: Route,
    stat: '#1',
    label: 'Georgia’s supply chain infrastructure ranking',
    tag: 'Supply Chain',
  },
  {
    icon: Users,
    stat: '1 in 12',
    label: 'U.S. workers employed in transportation or a related industry',
    tag: 'Workforce',
    span: 'md:col-span-2',
  },
  {
    icon: GraduationCap,
    stat: '73%',
    label: 'Employers say career pathways are the top workforce priority',
    tag: 'Education',
  },
  {
    icon: LineChart,
    stat: '2x',
    label: 'Faster wage growth for workers on structured career pathways',
    tag: 'Economic Mobility',
  },
  {
    icon: MapPin,
    stat: 'Metro Atlanta',
    label: 'A regional hub uniquely positioned to lead the conversation',
    tag: 'Regional Impact',
    span: 'md:col-span-2',
  },
];

export const WhyItMatters = () => {
  return (
    <section id="why" className="py-24 md:py-32 bg-aawta-surface">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl">
          <span className="overline text-aawta-magenta">Why This Matters</span>
          <h2 className="font-display font-bold text-4xl md:text-5xl mt-4 text-aawta-navy tracking-tight leading-[1.1]">
            The workforce challenge is real. So is the opportunity.
          </h2>
          <div className="divider-magenta mt-6" />
          <p className="mt-6 text-[17px] leading-relaxed text-aawta-muted">
            Transportation, logistics, and supply chain drive our economy — and they face
            some of the sharpest workforce gaps in the country. The Collaborative exists
            to translate that reality into pathways, partnerships, and progress.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-4 gap-5 md:gap-6">
          {stats.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.tag}
                data-testid={`stat-card-${s.tag.toLowerCase().replace(/\s+/g, '-')}`}
                style={{ animationDelay: `${i * 60}ms` }}
                className={`reveal group relative bg-white rounded-2xl p-7 border border-aawta-border shadow-aawta-soft hover:shadow-aawta-elevated hover:-translate-y-1 transition-all duration-300 ${
                  s.span || ''
                }`}
              >
                <div className="absolute top-0 left-7 right-7 h-[3px] bg-gradient-to-r from-aawta-magenta to-aawta-magenta/0 rounded-b-full" />
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-xl bg-aawta-navy/5 text-aawta-navy flex items-center justify-center group-hover:bg-aawta-magenta group-hover:text-white transition-colors duration-300">
                    <Icon className="h-5 w-5" strokeWidth={2} />
                  </div>
                  <span className="overline text-aawta-muted">{s.tag}</span>
                </div>
                <div className="font-display font-bold text-4xl md:text-5xl mt-6 text-aawta-navy tracking-tight">
                  {s.stat}
                </div>
                <p className="mt-3 text-[15px] leading-relaxed text-aawta-muted">
                  {s.label}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyItMatters;
